import React from "react";
import { useNavigate } from "react-router-dom";

const CleaningHub = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "60px 20px", textAlign: "center" }}>
      <h1
        style={{
          fontSize: "2.8rem",
          color: "#1b5e20",
          marginBottom: "15px",
          fontWeight: "800",
        }}
      >
        🟢 Cleaning
      </h1>

      <p
        style={{
          fontSize: "1.2rem",
          maxWidth: "650px",
          margin: "0 auto 50px",
          color: "#444",
        }}
      >
        Buy or swap cleaning clients, rounds.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "25px",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        {[
          {
            title: "Clients",
            text: "Buy individual cleaning clients",
            path: "/cleaning/listings",
          },
          {
            title: "Swaps",
            text: "Swap cleaning clients with other operators",
            path: "/cleaning/swaps",
          },
          {
            title: "Rounds",
            text: "Buy cleaning rounds",
            path: "/cleaning/rounds",
          },
       
        
        ].map((item) => (
          <div
            key={item.title}
            onClick={() => navigate(item.path)}
            style={{
              background: "#e8f5e9",
              padding: "30px 20px",
              borderRadius: "14px",
              cursor: "pointer",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
            }}
          >
            <h3 style={{ color: "#1b5e20", marginBottom: "10px" }}>
              {item.title}
            </h3>
            <p style={{ color: "#1b5e20", fontSize: "0.95rem" }}>
              {item.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CleaningHub;

